import React, { Fragment, useContext } from "react";
import CustomContext from "../../../_helper/Customizer";
import SidebarMenu from "./SidebarMenu";
import { Link } from "react-router-dom";
import logo from "../../../assets/images/logo/logo.png";

const Sidebar = () => {
    const { toggleIcon } = useContext(CustomContext);

    const closeOverlay = () => {
        const overlay = document.querySelector(".bg-overlay1");
        const links = document.querySelector(".sidebar-links");
        if (overlay) overlay.classList.remove("active");
        if (links) links.classList.remove("active");
    };

    return (
        <Fragment>
            <div className="bg-overlay1" onClick={closeOverlay}></div>
            <div className={`sidebar-wrapper ${toggleIcon ? "close_icon" : ""}`} sidebar-layout="stroke-svg">
                <div className="logo-wrapper py-4 px-4 border-bottom">
                    <Link to={`${process.env.PUBLIC_URL}/admin/dashboard`}>
                        <img className="img-fluid for-light" src={logo} alt="" style={{ width: '130px' }} />
                    </Link>
                    <div className="back-btn" onClick={closeOverlay}>
                        <i className="fa fa-angle-left"></i>
                    </div>
                </div>
                <div className="logo-icon-wrapper">
                    <Link to={`${process.env.PUBLIC_URL}/admin/dashboard`}>
                        <img className="img-fluid" src={logo} alt="" style={{ width: '32px' }} />
                    </Link>
                </div>
                <SidebarMenu />
            </div>
        </Fragment>
    );
};

export default Sidebar;
